import React from 'react'
import MaterialIcon from 'react-native-vector-icons/MaterialIcons'
import styled, { useTheme } from 'styled-components/native'
import DialogueTouchableOpacity from 'APP/Components/DialogueTouchableOpacity'
import Typography from 'APP/Converse/Typography'
import { useBottomDrawer } from '../BottomDrawerProvider'

const Container = styled.View`
  flex-direction: column;
`

const Title = styled(Typography)`
  color: ${({ theme }) => theme.colors.text};
  margin: ${({ theme }) => theme.metrics.baseMargin}px 0;
`

const Button = styled(DialogueTouchableOpacity)`
  align-self: flex-end;
`

export type BottomDrawerHeaderProps = {
  title?: string
  closeButtonProps?: Partial<{
    analyticsName: string
    testID: string
    hidden: boolean
  }>
}

function Header({ title, closeButtonProps }: BottomDrawerHeaderProps) {
  const theme = useTheme()
  const { onClose } = useBottomDrawer()

  return (
    <Container>
      {!closeButtonProps?.hidden && (
        <Button
          onPress={onClose}
          accessibilityLabel="Close drawer"
          accessibilityRole="button"
          testID="CLOSE_BTN"
          {...closeButtonProps}
        >
          <MaterialIcon
            name="close"
            size={theme.metrics.icon.small}
            color={theme.colors.text}
            testID="CLOSE_BTN_ICON"
          />
        </Button>
      )}
      <Title variant="h3">{title}</Title>
    </Container>
  )
}

export default Header
